module.exports = __webpack_public_path__ + "img/banner-22.702fed4d.jpg";